module["exports"] = [
  "(##) ####-####",
  "+55 (##) ####-####",
  "(##) #####-####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pt_BR/phone_number/formats.js
// module id = 2633
// module chunks = 2